import { render, staticRenderFns } from "./purchasingExchangeFix.vue?vue&type=template&id=ac22ad7c&scoped=true"
import script from "./purchasingExchangeFix.vue?vue&type=script&lang=js"
export * from "./purchasingExchangeFix.vue?vue&type=script&lang=js"
import style0 from "./purchasingExchangeFix.vue?vue&type=style&index=0&id=ac22ad7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac22ad7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac22ad7c')) {
      api.createRecord('ac22ad7c', component.options)
    } else {
      api.reload('ac22ad7c', component.options)
    }
    module.hot.accept("./purchasingExchangeFix.vue?vue&type=template&id=ac22ad7c&scoped=true", function () {
      api.rerender('ac22ad7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchasingManagement/exchange/purchasingExchangeFix.vue"
export default component.exports